import { Properties, RemoteGuide } from './types';
import usertour from 'usertour.js';
import config from 'common-module/src/config';
import { isPrivateVersion } from 'common-module/src/util';

export default class DefaultRemoteGuide implements RemoteGuide {
  async install () {
    if (isPrivateVersion) {
      return;
    }
    const userTourToken = config.VUE_APP_USERTOUR_TOKEN;
    if (!userTourToken) {
      throw new Error('UserTour token is not set');
    }
    await usertour.load();
    usertour.init(userTourToken);
    new MutationObserver(([mutation]) => {
      mutation.addedNodes.forEach(node => {
        const element = node as HTMLElement;
        if (element.classList?.contains('usertour-widget-root')) {
          const iframeList = Array.from(element.querySelectorAll('iframe'));
          iframeList.forEach(iframe => {
            iframe.addEventListener('load', () => {
              injectStyle(iframe.contentDocument!);
            });
          });
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  async identify(id: string | number, properties?: Properties) {
    if (isPrivateVersion) {
      return;
    }
    return usertour.identify(`${id}`, properties);
  }
  async setUserProperties(properties: Properties) {
    if (isPrivateVersion) {
      return;
    }
    return usertour.updateUser(properties);
  }
  async group(groupId: string, properties?: Properties, membership?: Properties) {
    if (isPrivateVersion) {
      return;
    }
    if (!groupId) {
      console.warn('RemoteGuide group groupId is not set');
      return;
    }
    return usertour.group(groupId, properties, { membership });
  }
  async setGroupProperties(properties: Properties) {
    if (isPrivateVersion) {
      return;
    }
    return usertour.updateGroup(properties);
  }
  async show(id: string | number, options?: any) {
    if (isPrivateVersion) {
      return;
    }
    return usertour.start(`${id}`, options);
  }
  close() {
    if (isPrivateVersion) {
      return;
    }
    usertour.endAll();
  }
  reset() {
    if (isPrivateVersion) {
      return;
    }
    usertour.reset();
  }
}

const injectStyle = (document: Document) => {
  const style = document.createElement('style');
  style.textContent = `
    body.usertour-widget-root {
        overflow: hidden;
    }
    .usertour-root .absolute:last-of-type:has(a) {
        display: none;
    }`;
  document.head.appendChild(style);
};